import { IsEnum } from 'class-validator';

import { WebsiteSliderTypeEnum } from '@onArte/shared/database/enums';

import { SliderUpdateModel } from './sliderUpdate.model';

export class SliderCreateModel extends SliderUpdateModel {
  @IsEnum(WebsiteSliderTypeEnum)
  public type: WebsiteSliderTypeEnum;
}
